package data

import com.kinoshazam.LANGUAGE
import com.kinoshazam.THEME
import com.kinoshazam.data.Storage
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import models.User

class ProfileRepository(
    private val httpClient: HttpClient,
    private val storage: Storage,
) {

    suspend fun getProfile(): User {
        val response = httpClient
            .get(urlString = "profile/info")
            .body<User>()
        return response
    }

    fun changeLang(lang: String) {
        storage.put(LANGUAGE, lang)
    }

    fun changeTheme(theme: String) {
        storage.put(THEME, theme)
    }
}